/* eslint-disable @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-use-before-define */
import { BaseOperation } from 'application/editor/operations/base';
import { MultitailArrow } from 'domain/entities/multitailArrow';
import { OperationType } from 'application/editor';
import { ReStruct, ReMultitailArrow } from 'application/render';
import { MULTITAIL_ARROW_KEY } from 'domain/constants';

interface MultitailArrowUpsertData {
  id?: number;
}

interface MultitailArrowDeleteData {
  id: number;
}

export class MultitailArrowUpsert extends BaseOperation {
  data: MultitailArrowUpsertData;
  constructor(private readonly multitailArrow: MultitailArrow, id?: number) {
    super(OperationType.MULTITAIL_ARROW_UPSERT);
    this.data = { id };
  }

  execute(reStruct: ReStruct) {
    const struct = reStruct.molecule;

    if (this.data.id === undefined) {
      this.data.id = struct.multitailArrows.newId();
    }
    const id = this.data.id;
    const item = this.multitailArrow.clone();
    struct.multitailArrows.set(id, item);
    reStruct.multitailArrows.set(id, new ReMultitailArrow(item));

    BaseOperation.invalidateItem(reStruct, MULTITAIL_ARROW_KEY, id, 1);
  }

  invert(): BaseOperation {
    return new MultitailArrowDelete(this.data.id!);
  }
}

export class MultitailArrowDelete extends BaseOperation {
  private multitailArrow?: MultitailArrow;
  data: MultitailArrowDeleteData;
  constructor(id: number) {
    super(OperationType.MULTITAIL_ARROW_DELETE);
    this.data = { id };
  }

  execute(reStruct: ReStruct) {
    const reMultitailArrow = reStruct.multitailArrows.get(this.data.id);

    if (!reMultitailArrow) {
      return;
    }

    this.multitailArrow = reMultitailArrow.multitailArrow.clone();
    reStruct.clearVisel(reMultitailArrow.visel);
    reStruct.markItemRemoved();
    reStruct.multitailArrows.delete(this.data.id);
    reStruct.molecule.multitailArrows.delete(this.data.id);
  }

  invert(): BaseOperation {
    return new MultitailArrowUpsert(this.multitailArrow!, this.data.id);
  }
}
